import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Line.module.scss';
import cn from 'classnames';
const Line = ({ className }) => {
    return _jsx("div", { className: cn(styles.element, className) });
};
export default Line;
